export default function EmptyPanel() {
  return null
}
